import DataBar from './data-bar';

export default DataBar;